import { SAVE_TRACK_SCREEN_TIMING } from "Constants/actionConstants";
import React, { Component } from "react";
import { connect } from "react-redux";
import { isValueThere } from "Utils/index";
import {
  getItemFromSessionStorage,
  removeItemToSessionStorage,
  setItemToSessionStorage,
} from "Utils/sessionStorage";

class ScreenTimeTrack extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    this.handleTrackScreenTiming();
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    // this.handleTrackScreenTiming();
    // console.log("start unmount activities for ScreenTimeTracker");
    const track_href = getItemFromSessionStorage("track_href");
    const screen_landing_time = getItemFromSessionStorage(
      "screen_landing_time",
    );
    const payload = {
      track_href,
      screen_landing_time,
      screen_leaving_time: new Date().getTime(),
    };
    this.handleSaveTrackScreenTiming(payload);
    removeItemToSessionStorage("track_href");
    removeItemToSessionStorage("screen_landing_time");
    // console.log("end unmount activities for ScreenTimeTracker");
  }

  handleBeforeUnload = (event) => {
    // event.preventDefault();
    // console.log('MMMMMMMMMMMMM', event)
    // console.log('User is about to leave or refresh the page.');
    // this.handleTrackScreenTiming()
    // console.log("start BeforeUnload activities for ScreenTimeTracker");
    // const track_href = getItemFromSessionStorage("track_href");
    const track_href = window.location.href;
    const screen_landing_time = getItemFromSessionStorage(
      "screen_landing_time",
    );
    const payload = {
      track_href,
      screen_landing_time,
      screen_leaving_time: new Date().getTime(),
    };

    const onSuccess = () => {
      removeItemToSessionStorage("track_href");
      removeItemToSessionStorage("screen_landing_time");
      removeItemToSessionStorage("temp_user_info");
      // console.log("end BeforeUnload activities for ScreenTimeTracker");
    }

    this.handleSaveTrackScreenTiming(payload, onSuccess);
  };

  handleSaveTrackScreenTiming = (payload, onSuccess) => {
    const { dispatch } = this.props;
    let screenInfoDetailsItem = this.props.screenInfoDetailsItem || {};
    dispatch({
      type: SAVE_TRACK_SCREEN_TIMING,
      payload: {
        ...payload,
        screen_id: screenInfoDetailsItem.screen_id,
        screen_name: screenInfoDetailsItem.screen_name,
        // href_url: screenInfoDetailsItem.href_url,
      },
      onSuccess
    });
  };

  handleTrackScreenTiming = () => {
    const track_href = getItemFromSessionStorage("track_href");
    if (isValueThere(track_href)) { // fallback
      if (track_href !== window.location.href) {
        const screen_landing_time = getItemFromSessionStorage(
          "screen_landing_time",
        );
        const payload = {
          track_href,
          screen_landing_time,
          screen_leaving_time: new Date().getTime(),
        };
        this.handleSaveTrackScreenTiming(payload);
      }
      setItemToSessionStorage("track_href", window.location.href);
      setItemToSessionStorage("screen_landing_time", new Date().getTime());
    } else {
      setItemToSessionStorage("track_href", window.location.href);
      setItemToSessionStorage("screen_landing_time", new Date().getTime());
    }
  };

  render() {
    return null;
  }
}

export default connect(null, null)(ScreenTimeTrack);
